var render, staticRenderFns
import script from "./EmptyPanel.vue?vue&type=script&lang=jsx&"
export * from "./EmptyPanel.vue?vue&type=script&lang=jsx&"
import style0 from "./EmptyPanel.vue?vue&type=style&index=0&id=4dc0bb2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports